import React, { Component } from 'react';
import { compose, graphql, withApollo } from 'react-apollo';
import { Table, Button, Breadcrumb } from 'antd';
import AntIcon from '../shared/components/AntIcon';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import { ListSneakerModelsQuery, UpdateSneakerModelMutation } from './queries';


class List extends Component {
  constructor(props) {
    super(props);

    this.handlePriorityUpdate = this.handlePriorityUpdate.bind(this);
  }

  handlePriorityUpdate(id, oldPriority, change) {
    const { client } = this.props;
    const priority = (oldPriority || 0) + (change === 'up' ? 1 : -1);
    client.mutate({
      mutation: UpdateSneakerModelMutation,
      variables: { id, update: { orderPriority: priority } },
    }).then(() => { this.props.history.push("/model"); })
      .catch(e => alert(`Failed to change ordering: ${e.message}.`));
  }

  componentDidMount() {
    const { loading, fetchMore, SneakerModels } = this.props.data;
    if (!loading && SneakerModels) {
      let updatedSince = _(SneakerModels).map('updatedAt').max();
      if (!updatedSince) {
        updatedSince = "1011-12-19T15:28:46.493Z";
      } else {
        var newDate=new Date(updatedSince);
        newDate.setDate(newDate.getDate() - 1); /* for timezone */
        updatedSince = newDate.toISOString();
      }
      fetchMore({
        variables: {
          filter: {
            "updatedAt": { "$gt": updatedSince },
          },
        },
        updateQuery: (previousResult, { fetchMoreResult, _variables }) => {
          const newIds = fetchMoreResult.SneakerModels.map(s => s._id);
          const SneakerModels = _(previousResult.SneakerModels)
            .reject(s => newIds.includes(s._id))
            .concat(fetchMoreResult.SneakerModels)
            .orderBy(['orderPriority', 'date'], ['desc', 'asc'])
            .value();
          return { SneakerModels };
        },
      })
    }
  }

  render() {
    const { loading, error, SneakerModels } = this.props.data;
    if (error) return `Error: ${error}`;

    const imageStyle = { objectFit: 'cover', height: 100, width: 160 };
    const makeButtonProps = (id, priority, change) => {
      return {
        key: change, type: `arrow-${change}`,
        style: { cursor: 'pointer' },
        onClick: () => this.handlePriorityUpdate(id, priority, change),
      }
    }

    const Columns = [
      {
        title: '',
        dataIndex: 'orderPriority',
        width: 100,
        render: (priority, { _id }) => {
          return ([
            <AntIcon {...makeButtonProps(_id, priority, 'up')} />,
            <span key="priority">{priority > 10000 ? priority - 100000 : priority}</span>,
            <AntIcon {...makeButtonProps(_id, priority, 'down')} />,
          ]);
        },
      },
      {
        title: 'Date',
        dataIndex: 'date',
        sorter: (a, b) => a.date.localeCompare(b.date),
      },
      {
        title: 'Name',
        dataIndex: 'name',
        sorter: (a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
        render: (text, record) => <Link to={`/model/${record._id}/edit`}>{text}</Link>,
      },
      {
        title: 'Image',
        key: 'thumbnail',
        dataIndex: 'images',
        width: 160,
        render: (images, { name }) => {
          if (images && images.length > 0) {
            let url = images[0];
            return (
              <img alt={name} style={imageStyle} src={url} />
            );
          } else {
            return (
              <img alt="" />
            );
          }
        },
      }
    ];

    const FilteredSneakerModels = _.reject(SneakerModels, 'isDeleted');

    return (
      <div id="model-list">
        <Breadcrumb>
          <Breadcrumb.Item>Model</Breadcrumb.Item>
        </Breadcrumb>

        <div className="container">
          <h4>
            Manage Model
            <Button.Group size="small" className="is-right">
              <Button>
                <Link to="/model/new"><AntIcon type="plus" /> New Item</Link>
              </Button>
            </Button.Group>
          </h4>

          <Table
            scroll={{ x: 500 }}
            columns={Columns}
            loading={SneakerModels ? false : loading}
            dataSource={FilteredSneakerModels}
            rowKey='_id'
            pagination={{
              pageSize: 30,
              showSizeChanger: true,
              pageSizeOptions: ['30', '60', '100', '200'],
              showTotal: (total) => `Total ${total} items`,
            }}
          />
        </div>
      </div>
    );
  }
}

export default compose(
  graphql(ListSneakerModelsQuery),
  withApollo,
)(List);